import {
    NavLink
  } from "react-router-dom";
import {IconHome ,IconBandage , IconUsers , IconFriends, IconCalendarTime, IconBuildingWarehouse } from '@tabler/icons-react';
import { useEffect,useState,useCallback } from "react";
import { useAppContext } from "../../../context/AppContext";

const Footer = () => {
    const { user } = useAppContext();
    const mhsnav = [
        {
            name:'Home',
            link:'dashboard',
            icon:<IconHome size={25}/>
        },
        {
            name:'Consultation',
            link:'consultations',
            icon:<IconCalendarTime size={25}/>,
            permission: 'consultations',
        },
        {
            name:'Patients',
            link:'patients',
            icon:<IconUsers size={25}/>,
            permission: 'patients',
        },
        {
            name:'Dosages',
            link:'dosages',
            icon:<IconBandage size={25}/>,
            permission: 'dosages',
        },
        {
            name:'Centres',
            link:'centres',
            icon:<IconBuildingWarehouse size={25}/>,
            permission: 'centres',
        }
    ].filter((item) => user?.role !== 'staff' || !item.permission || user.permissions?.includes(item.permission))

    return (
         (
            <div className={`flex justify-around fixed bottom-0 w-full shadow-md py-1 pt-3 text-mhs-secondary text-xs !z-10`} style={{background: 'linear-gradient(180deg, #FFF5E1 0%, #FDE7B7 60%)'}}>
                {mhsnav.map((navDetails) => (
                    
                    <NavLink
                        key={navDetails.link}
                        className={({ isActive }) =>
                            isActive ? 'nav-btn active' : 'nav-btn'
                        }
                        to={navDetails.link}
                    >
                        <div className="flex flex-col justify-center items-center">
                            <span className="nav-icon font-extrabold !text-xl">{navDetails.icon}</span>
                            <span>{navDetails.name}</span>
                        </div>
                    </NavLink>
                ))}
            </div>
        )
    );
};

export default Footer;
